export default __webpack_public_path__ + "static/media/digitalfirst.2dc29603.svg";